<!-- 捐赠收据页面 -->
<template>
  <div class="receiptDiv">
    <div class="donation">
      <div class="donationImgDiv">
        <van-image :src="this.donation.images" alt="捐赠项目图片" class="donationImg" />
        <div class="imgTipDiv">
          <div class="tipWords">{{ this.donation.typeName }}</div>
        </div>
      </div>
      <div class="donationName">{{ this.donation.title }}</div>
      <div class="donationMoneyDiv">
        <div>目标金额：</div>
        <div style="color: #00706E">￥{{ this.donation.targetAmount }}元</div>
      </div>
    </div>
    <div class="donationReceiptDiv">
      <div class="titleDiv">
        <div class="titleIcon"></div>
        <div class="titleWord">捐赠收据</div>
      </div>
      <div class="donationReceipt">
        <el-radio v-model="form.isAskReceipts" label="0">
          否<span class="donationReceiptInfo">（我们将为您保管收据，可以随时索要）</span>
        </el-radio>
        <br />
        <hr />
        <el-radio v-model="form.isAskReceipts" label="1">
          是<span class="donationReceiptInfo">（请准确填写您的联系方式，方便我们邮寄收据）</span>
        </el-radio>
      </div>
    </div>
    <div class="donationDataDiv">
      <div class="titleDiv">
        <div class="titleIcon"></div>
        <div class="titleWord">捐赠信息</div>
      </div>
      <div class="donationData">
        <el-form ref="form" :rules="rules" :model="form">
          <el-form-item prop="name">
            <el-input v-model="form.name" placeholder="请输入捐赠人/集体姓名"></el-input>
          </el-form-item>
          <el-form-item prop="phone">
            <el-input v-model="form.phone" placeholder="请输入捐赠人联系电话"></el-input>
          </el-form-item>
          <el-form-item prop="teacher">
            <el-input v-model="form.teacher" placeholder="请输入捐赠人恩师"></el-input>
          </el-form-item>
          <el-form-item prop="email" v-if="form.isAskReceipts == '1'">
            <el-input v-model="form.email" placeholder="请输入捐赠人邮箱"></el-input>
          </el-form-item>
          <el-form-item prop="danwei" v-if="form.isAskReceipts == '1'">
            <el-input v-model="form.danwei" placeholder="请输入捐赠人开票公司名称"></el-input>
          </el-form-item>
          <el-form-item prop="num" v-if="form.isAskReceipts == '1'">
            <el-input v-model="form.num" placeholder="请输入捐赠人开票公司税号"></el-input>
          </el-form-item>
          <el-form-item prop="address" v-if="form.isAskReceipts == '1'">
            <el-input v-model="form.address" placeholder="请输入捐赠人邮寄地址"></el-input>
          </el-form-item>
          <el-radio-group v-model="form.sexReceipt">
            <el-radio :label="1">先生</el-radio>
            <el-radio :label="2">女士</el-radio>
            <el-radio :label="3">集体</el-radio>
          </el-radio-group>
          <el-radio-group v-model="form.statusReceipt">
            <el-radio :label="1">校友</el-radio>
            <el-radio :label="2">在校生</el-radio>
            <el-radio :label="3">其他</el-radio>
          </el-radio-group>
        </el-form>
      </div>
    </div>
    <div class="donationWishesDiv">
      <div class="titleDiv">
        <div class="titleIcon"></div>
        <div class="titleWord">捐赠祝语</div>
      </div>
      <div class="donationWishes">
        <el-input
          type="textarea"
          resize="none"
          rows="4"
          placeholder="写点什么"
          v-model="form.mes"
          maxlength="30"
          show-word-limit
        >
        </el-input>
      </div>
    </div>
    <div class="btnDiv">
      <button class="btn" @click="successForm">完 成</button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      donation: '',
      form: {
        // id: window.localStorage.getItem("donateId"),
        openid: window.localStorage.getItem('openid'),
        isAskReceipts: '1',
        name: '',
        phone: '',
        teacher: '',
        email: '',
        address: '',
        num: '',
        danwei: '',
        // sexReceipt: 1,
        // statusReceipt: 1,
        sex:'',
        status:'',
        mes: '',
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        teacher: [{ required: true, message: '请输入恩师姓名', trigger: 'blur' }],
        email: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
        address: [{ required: true, message: '请输入邮寄地址', trigger: 'blur' }],
        num: [
          {
            required: true,
            message: '请输入捐赠人开票公司税号',
            trigger: 'blur',
          },
        ],
        danwei: [
          {
            required: true,
            message: '请输入捐赠人开票公司名称',
            trigger: 'blur',
          },
        ],
        totalMoney: '',
      },
    };
  },
  created() {
    this.getDonation();
  },
  methods: {
    async getDonation() {
      this.totalMoney = window.sessionStorage.getItem('totalMoney');
      const result = await this.$http.get("/donates/getDonateById", {
        params: { id: window.localStorage.getItem("donateId"), openid: window.localStorage.getItem("openidDona") },
      });
      this.donation = result.data;
    },
    async successForm() {

      // if(this.form.statusReceipt == '1'){
      //   this.form.status = '校友'
      // }else if(this.form.statusReceipt == '2'){
      //   this.form.status = '在校生'
      // }else if(this.form.statusReceipt == '3'){
      //   this.form.status = '其他'
      // }
      // if(this.form.sexReceipt == '1'){
      //   this.form.sex = '先生'
      // }else if(this.form.sexReceipt == '2'){
      //   this.form.sex = '在校生'
      // }else if(this.form.sexReceipt == '3'){
      //   this.form.sex = '集体'
      // }
      // console.log('this.form',this.form)

      this.$refs.form.validate(async (valid) => {
        // 请求api之前，前端先进行的一个校验
        if (!valid) {
          return;
        }
        const result = await this.$http({
          url: '/donates/updateDonateRecord',
          method: 'POST',
          // headers: { "content-type": "application/x-www-form-urlencoded" },
          data: this.form,
        });
        if (result.data == true) {
          this.gotoDonatingSucc();
        } else {
          this.$total('提交失败了，请重试');
        }
      });
    },
    gotoDonatingSucc() {
      return this.$router.push({
        path: '/donationSucc',
        query: { donateId: window.localStorage.getItem("donateId") },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.receiptDiv {
  .donation {
    display: flex;
    flex-direction: column;
    align-items: center;

    .donationImgDiv {
      position: relative;
      width: 100%;
      height: 13.03rem;

      .donationImg {
        height: 100%;
        width: 100%;
      }

      .imgTipDiv {
        position: absolute;
        left: 0;
        top: 0;
        width: 9.14rem;
        height: 1.9rem;
        line-height: 1.9rem;
        background: linear-gradient(-90deg, #00706E, #00706E);
        border-radius: 0rem 0rem 0.76rem 0rem;
        text-align: center;

        .tipWords {
          font-size: 1.07rem;
          color: #ffffff;
        }
      }
    }

    .donationName {
      width: 90%;
      margin-top: 1.37rem;

      font-size: 1.22rem;
      color: #333333;
      line-height: 1.33rem;
    }

    .donationMoneyDiv {
      display: flex;
      width: 90%;
      margin-top: 10px;
      font-size: 1.07rem;
      color: #333333;
      line-height: 1.33rem;
    }
  }

  .donationReceiptDiv {
    display: flex;
    align-items: center;
    flex-direction: column;

    .donationReceipt {
      width: 90%;
      margin-top: 10px;
      background: #ffffff;
      border: 1px solid #e1e1e1;
      border-radius: 15px;

      .donationReceiptInfo {
        font-size: 0.99rem;
        color: #666666;
        line-height: 1.33rem;
      }

      .el-radio {
        display: flex;
        align-items: center;
        padding: 1.9rem 0.8rem;
        white-space: normal;
      }

      /deep/ .el-radio__label {
        margin-left: 0.02rem;
      }

      hr {
        margin-block-start: 0;
        margin-block-end: 0;
        background-color: #e1e1e1;
        height: 1px;
        border: 0;
      }
    }
  }

  .donationDataDiv {
    display: flex;
    flex-direction: column;
    align-items: center;

    .donationData {
      width: 90%;
      margin-top: 10px;
      background: #ffffff;
      border: 1px solid #e1e1e1;
      border-radius: 15px;

      .el-form {
        margin-top: 20px;
        padding: 0 10px;

        .el-form-item {
          margin-bottom: 20px;
        }

        /deep/.el-input__inner {
          background-color: #f5f5f5;
        }

        .el-radio-group {
          margin-bottom: 20px;
        }
      }
    }
  }

  .donationWishesDiv {
    display: flex;
    flex-direction: column;
    align-items: center;

    .donationWishes {
      width: 90%;
      margin: 10px 0 30px 0;

      /deep/.el-textarea__inner {
        border-radius: 15px;
      }
    }
  }

  .btnDiv {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 10px;

    .btn {
      width: 90%;
      padding: 10px 0;
      background: linear-gradient(270deg, #00706E, #00706E);
      border: 0;
      font-size: 1.1rem;
      font-weight: bold;
      color: #ffffff;
      border-radius: 20px;
    }
  }

  .titleDiv {
    height: 7vw;
    display: flex;
    width: 90%;
    margin-top: 30px;

    .titleIcon {
      width: 4px;
      height: 6vw;
      background-color: #00706E;
      border-radius: 15px;
    }

    .titleWord {
      padding-left: 10px;
      font-size: 1.3em;
      font-weight: bold;
      color: #333333;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/donation/Receipt.vue